var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25.0001C50 11.193 38.8071 0.00012207 25 0.00012207C11.1929 0.00012207 0 11.193 0 25.0001C0 38.8072 11.1929 50.0001 25 50.0001C38.8071 50.0001 50 38.8072 50 25.0001Z",
    fill: "#51DC6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25.0001C38 17.8204 32.1797 12.0001 25 12.0001C17.8203 12.0001 12 17.8204 12 25.0001C12 32.1798 17.8203 38.0001 25 38.0001C32.1797 38.0001 38 32.1798 38 25.0001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5039 25.1371L23.6191 29.3561L31.2891 21.5001",
    stroke: "#51DC6B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/toast-success-icon.7d222af9df561c68813fd84b19d676b6.svg";
export { ForwardRef as ReactComponent };